// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"166ad891","952":"04147353"}[chunkId] + ".chunk.js";
};